import {
  PASSWORD_RULE_LABELS,
  evaluatePasswordRules,
  type PasswordRules,
} from '@wineryxplorer/shared';

interface PasswordRuleItemProps {
  satisfied: boolean;
  label: string;
}

const PasswordRuleItem = ({ satisfied, label }: PasswordRuleItemProps) => (
  <li
    className={`flex items-center gap-2 text-xs ${
      satisfied ? 'text-green-600' : 'text-gray-500'
    }`}
  >
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-[10px] font-bold ${
        satisfied ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-400'
      }`}
    >
      {satisfied ? '\u2713' : '\u2022'}
    </span>
    <span>{label}</span>
  </li>
);

interface PasswordRequirementsProps {
  password: string;
  rules?: PasswordRules;
  heading?: string;
}

export const PasswordRequirements = ({
  password,
  rules,
  heading = 'Your password must contain:',
}: PasswordRequirementsProps) => {
  const evaluated = rules ?? evaluatePasswordRules(password);
  return (
    <div>
      <p className="text-xs font-medium text-gray-700 mb-2">{heading}</p>
      <ul className="space-y-1">
        {PASSWORD_RULE_LABELS.map(({ key, label }) => (
          <PasswordRuleItem key={key} satisfied={evaluated[key]} label={label} />
        ))}
      </ul>
    </div>
  );
};
